export default "__VITE_ASSET__eUelPWuA__"